export const convertMinutesStrToHoursMinutes = (minutesStr: string): string => {
    return convertMinutesToHoursMinutes(parseInt(minutesStr, 10))
}

export const convertMinutesToHoursMinutes = (totalMinutes: number): string => {
    // Handle invalid input
    if (isNaN(totalMinutes) || totalMinutes < 0) {
        throw new Error('Invalid input: must be a non-negative numeric string')
    }

    // Handle zero minutes
    if (totalMinutes === 0) {
        return '0m'
    }

    const hours = Math.floor(totalMinutes / 60)
    const minutes = totalMinutes % 60

    // Build result string
    const parts: string[] = []

    if (hours > 0) {
        parts.push(`${hours}h`)
    }

    if (minutes > 0) {
        parts.push(`${minutes}m`)
    }

    return parts.join(' ')
}
